// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { isInAppBrowser } from '@/utils/webviewDetect';
import { retryOnTransientNetwork } from '@/utils/networkResilience';

const SUPABASE_URL = "https://tnjvdswykmzvxcwfoycj.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InRuanZkc3d5a216dnhjd2ZveWNqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDk5NDIxMDcsImV4cCI6MjA2NTUxODEwN30.qc9zncQWDzGhFyXgPopIDUkolxhweFMqO2i8oZH1iKM";

// In-app browsers (Facebook/Instagram) have issues with localStorage and cookie
// access. Disable session persistence to avoid silent auth failures in WebViews
// while keeping full auth UX in normal browsers.
const authOptions = isInAppBrowser
  ? {
      persistSession: false,
      autoRefreshToken: false,
      detectSessionInUrl: false,
    }
  : {};

// Custom fetch that wraps native fetch with retry logic for transient network
// errors. This ensures ALL Supabase SDK requests (REST, auth, storage) benefit
// from the resilience layer inside Meta in-app browsers.
const resilientFetch: typeof globalThis.fetch = (input, init) => {
  return retryOnTransientNetwork(() => globalThis.fetch(input, init));
};

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: authOptions,
  global: {
    fetch: resilientFetch,
  },
  realtime: {
    params: { eventsPerSecond: 0 },
  },
});
